export const normalizeZAphone = (value: string) => {
  const digits = value.replace(/[^\d+]/g, "")

  // international forman +27 -> local 0
  if (digits.startsWith("+27")) {
    return "0" + digits.slice(3)
  }

  // if digits without +
  const justDigits = value.replace(/[^\d]/g, "")

  // like international but without + (27XXXXXXXXX)
  if (justDigits.startsWith("27") && justDigits.length === 11) {
    return "0" + justDigits.slice(2)
  }

  return justDigits
}

export const formatPhone = (value: string) => {
  const digits = normalizeZAphone(value).slice(0, 10)

  return digits.replace(/(\d{3})(\d{3})(\d{0,4})/, (_: string, a: string, b: string, c: string) =>
    c ? `(${a}) ${b} ${c}` : `(${a}) ${b}`
  )
}
